import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { isEmpty } from 'lodash';
import { Spin } from 'antd';
import {
  setupRendering,
  renderFrameData,
  renderBarScale,
  renderFrameDataCache,
} from '~/utils/beanField';
import { SimulateSection, TerminateSimulateBtn, CenterBtn, SpinCenter, DivNodata } from './style';
import Branch from './Branch';

const Nodata = () => (
  <DivNodata>
    <div>ไม่สามารถแสดงผลข้อมูลและจำลองสถาณการณ์</div>
    <div>เนื่องจากไม่พบข้อมูลในช่วงเวลาที่ได้กำหนด</div>
  </DivNodata>
);

class PressureSimulate extends Component {
  constructor(props) {
    super(props);
    this.frameCache = {};
  }

  state = {
    runSimulate: false,
    isForceRender: typeof this.props.forceRenderIndex === 'number',
  };

  componentDidMount() {
    this.isCurrentPage = true;
    this.bindDomToSetUpRender();
  }

  componentDidUpdate() {
    const { forceRenderIndex } = this.props;
    const { runSimulate, isForceRender } = this.state;
    const startIndex = isForceRender ? forceRenderIndex : 0;

    if (runSimulate || isForceRender) {
      setTimeout(this.runSimulator(startIndex), 500);
    }
  }

  componentWillUnmount() {
    this.isCurrentPage = false;
  }

  stopSimulateHandler() {
    this.setState({ runSimulate: false });
  }

  startSimulateHandler() {
    this.setState({ runSimulate: true });
  }

  bindDomToSetUpRender() {
    const { damSectionImage, forceRenderIndex } = this.props;
    const { isForceRender } = this.state;
    const startIndex = isForceRender ? forceRenderIndex : 0;

    // Initial simulation
    setupRendering({
      canvasPressureId: document.getElementById('renderPressure'),
      canvasDamSectionId: document.getElementById('renderSection'),
      damSectionImage,
    });

    // Force render for non-simulation
    if (isForceRender) {
      setTimeout(this.runSimulator(startIndex), 500);
    }
  }

  runSimulator(frameIndex = 0) {
    const { pressureData } = this.props;
    const { isForceRender } = this.state;
    const totalFrame = pressureData.data.length;
    const { time: dateTime } = pressureData.data[frameIndex];

    if (this.isCurrentPage) {
      if (isEmpty(this.frameCache) || isEmpty(this.frameCache[dateTime])) {
        if (frameIndex === 0) {
          renderBarScale();
        }

        renderFrameData(pressureData.data[frameIndex]).then((dataURL) => {
          this.frameCache[dateTime] = dataURL;
          if (this.state.runSimulate && !isForceRender) {
            this.runSimulator((frameIndex + 1) % totalFrame);
          }
        });
      } else {
        renderFrameDataCache(this.frameCache[dateTime]).then(() => {
          if (this.state.runSimulate && !isForceRender) {
            this.runSimulator((frameIndex + 1) % totalFrame);
          }
        });
      }
    }
  }

  simulationController = () => {
    const { runSimulate } = this.state;
    const {
      pressureData: { data },
    } = this.props;

    return [
      runSimulate && (
        <TerminateSimulateBtn
          key="stopBtn"
          type="danger"
          onClick={() => this.stopSimulateHandler()}
        >
          หยุดระบบ
        </TerminateSimulateBtn>
      ),
      !runSimulate && data && (
        <CenterBtn
          key="startBtn"
          type="primary"
          size="large"
          onClick={() => this.startSimulateHandler()}
        >
          เริ่มระบบจำลองสถานการณ์
        </CenterBtn>
      ),
    ];
  };

  render() {
    const { isLoading } = this.props;
    const { isForceRender } = this.state;

    return (
      <SimulateSection>
        <canvas id="renderPressure" width="1200" height="500" />
        <canvas id="renderSection" width="1200" height="500" />

        {!isForceRender && this.simulationController()}

        {isLoading === true && (
          <SpinCenter>
            <Spin />
          </SpinCenter>
        )}
      </SimulateSection>
    );
  }
}

export default Branch(withRouter(PressureSimulate), Nodata);



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureSimulate/PressureSimulate.js